const CDN_LOGO_BASE = "https://d2lyw5vkb9es5b.cloudfront.net";

export const customerLogos = [
  { name: "Rakuten TV", src: "/assets/customer-logos/rakuten-tv.svg" },
  { name: "PillTime", src: `${CDN_LOGO_BASE}/logo_1.webp` },
  { name: "24 Hour Home Care", src: "/assets/customer-logos/24-hour-home-care.svg" },
  { name: "Trivago", src: "/assets/customer-logos/trivago.svg" },
  { name: "World YMCA", src: `${CDN_LOGO_BASE}/logo_4.webp` },
  { name: "Pacific West Diagnostic Imaging", src: `${CDN_LOGO_BASE}/logo_5.webp` },
  { name: "Cambri", src: "/assets/customer-logos/cambri.svg" },
  { name: "Elements Dining Group", src: `${CDN_LOGO_BASE}/logo_6.webp` },
  { name: "LSports", src: `${CDN_LOGO_BASE}/logo_7.webp` },
  { name: "Sacred Heart University", src: `${CDN_LOGO_BASE}/logo_8.webp` },
  { name: "Customer logo", src: `${CDN_LOGO_BASE}/logo_9.webp` },
  { name: "Header", src: `${CDN_LOGO_BASE}/logo_10.webp` },
  { name: "Debt Consultants Group", src: `${CDN_LOGO_BASE}/logo_11.webp` },
  { name: "United Wheels", src: `${CDN_LOGO_BASE}/logo_12.webp` },
  { name: "Clicks", src: `${CDN_LOGO_BASE}/logo_13.webp` },
  { name: "NSC", src: `${CDN_LOGO_BASE}/logo_14.webp` },
  { name: "Phothera", src: `${CDN_LOGO_BASE}/logo_15.webp` },
  { name: "Huffy", src: `${CDN_LOGO_BASE}/logo_17.webp` },
  { name: "Antlers", src: `${CDN_LOGO_BASE}/logo_18.webp` },
  { name: "Customer logo", src: `${CDN_LOGO_BASE}/logo_19.webp` },
  { name: "Marks Supply", src: `${CDN_LOGO_BASE}/logo_20.webp` },
  { name: "Incertify", src: `${CDN_LOGO_BASE}/logo_21.webp` },
  { name: "AA Medical", src: `${CDN_LOGO_BASE}/logo_22.webp` },
  { name: "Moss Home", src: `${CDN_LOGO_BASE}/logo_23.webp` },
  { name: "Customer logo", src: `${CDN_LOGO_BASE}/logo_24.webp` },
  { name: "Block Earner", src: `${CDN_LOGO_BASE}/logo_26.webp` },
  { name: "NHP", src: `${CDN_LOGO_BASE}/logo_16.webp` },
  { name: "Discovery Place", src: `${CDN_LOGO_BASE}/logo_2.webp` },
];

export const customerTestimonials = [
  {
    company: "24 Hour Home Care",
    quote:
      "There were moments in this engagement where the partnership felt less like working with a vendor and more like having extra hands on our own team. That is a rare thing in our world.",
    author: "Sean McCormick",
    role: "Project Lead",
  },
  {
    company: "Cambri",
    quote:
      "Antrazal has been instrumental in a myriad of business and revenue operations processes that involved more than just our CRM system implementation. Throughout the entire project lifecycle they have always been there 100%, and have contributed to the growth of our company.",
    author: "Csongor Doma",
    role: "VP of Revenue Operation",
  },
  {
    company: "Trivago",
    quote:
      "Antrazal has been an outstanding partner. They delivered a highly complex project that other consultants weren’t sure was achievable—and they did it on time and to a very high standard. Their support has been responsive and reliable throughout. We’re excited to continue working with them long-term, not just on this one project.",
    author: "Marius Tendick",
    role: "Customer Success & Operations Lead",
  },
  {
    company: "PillTime",
    quote:
      "Excellent support. Always went above and beyond to implement the most effective solution in a timely manner. Very experienced!",
    author: "Gemma Haggarty",
    role: "Marketing Director",
  },
  {
    company: "World YMCA",
    quote:
      "We work with Antrazal since they started. They really boost our use of the Salesforce environment. Their major strength: they really put at the maximum the build in features of Salesforce without trying to force us to buy costly third-party solution. They are fantastic to clarify and understand the requirements and even anticipate them. The most fantastic achievement, they build in a voting system for our General Assembly! A master piece that save us hours of work.",
    author: "Claude-Alain Danthe",
    role: "Digital Head",
  },
  {
    company: "Stanley Martin Homes",
    quote:
      "It was great experience working with the team on the custom email template project. They were all incredibly communicative, organized, and responsive throughout the entire process. The final deliverables were exactly what was needed. I really appreciate how smoothly everything went - thank you to the whole team for making it such an easy and efficient collaboration.",
    author: "Holly Macasek",
    role: "Director of Sales and Marketing Technology",
  },
];

export const events = [
  {
    name: "21st YMCA World Council",
    shortName: "YMCA World Council 2026",
    date: "19–25 July 2026",
    location: "Toronto, Canada",
    url: "https://worldcouncil.ymca.int/",
    theme: "ymca",
    description:
      "Antrazal will be attending the global YMCA gathering focused on movement leadership, collaboration, and the future of community impact.",
  },
  {
    name: "Dreamforce 2026",
    shortName: "Dreamforce 2026",
    date: "15–17 September 2026",
    location: "San Francisco, USA and Salesforce+",
    url: "https://www.salesforce.com/dreamforce/",
    theme: "dreamforce",
    description:
      "Meet Antrazal at Salesforce’s flagship event for enterprise technology, customer success, AI, data, and platform innovation.",
  },
  {
    name: "Rystad Energy Summit Americas",
    shortName: "Energy Summit Americas",
    date: "10 September 2026",
    location: "Marriott Marquis Houston, USA",
    url: "https://rystadsummit.com/americas",
    theme: "rystad",
    description:
      "Antrazal will join energy leaders and decision-makers discussing the outlook, technology, and operating priorities shaping the Americas.",
  },
];

export const caseStudies = [
  {
    title: "Agentforce on Slack",
    category: "Employee service and operations",
    description:
      "A governed operating model for AI assistance in Slack, with Salesforce controlling data, actions, permissions, escalation, and auditability.",
    cover: "/assets/case-studies/agentforce-slack-cover.jpg",
    pdf: "/assets/case-studies/WhitePaper_Agentforce_on_Slack_Case_Study.pdf",
  },
  {
    title: "Agentforce Voice with Amazon Connect",
    category: "Voice service",
    description:
      "A governance-first pattern for AI-powered voice self-service, Salesforce-grounded responses, and context-rich live-agent handoff.",
    cover: "/assets/case-studies/agentforce-voice-cover.jpg",
    pdf: "/assets/case-studies/WhitePaper_Antrazal_Agentforce_AWSVoice.pdf",
  },
  {
    title: "Agentforce on Field Service Mobile",
    category: "Field operations",
    description:
      "Grounded answers and approved Salesforce actions at the point of work, without weakening operational controls for mobile teams.",
    cover: "/assets/case-studies/agentforce-field-service-cover.jpg",
    pdf: "/assets/case-studies/WhitePaper_Antrazal_Agentforce_FieldServiceLightningApp.pdf",
  },
  {
    title: "Agentforce Case-to-Email",
    category: "Customer service",
    description:
      "A controlled Email-to-Case response model using grounded Agentforce drafts, approved templates, and event-driven orchestration.",
    cover: "/assets/case-studies/agentforce-case-email-cover.jpg",
    pdf: "/assets/case-studies/WhitePaper_Antrazal_Agentforce_CaseToEmail.pdf",
  },
  {
    title: "Agentforce on Experience Cloud",
    category: "Digital self-service",
    description:
      "Governed portal self-service with approved Salesforce actions, knowledge grounding, identity controls, and clear human handoff.",
    cover: "/assets/case-studies/agentforce-experience-cloud-cover.jpg",
    pdf: "/assets/case-studies/WhitePaper_Antrazal_Agentforce_ExperienceCloudSite.pdf",
  },
];
